<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Dedication">To my friends at Fletcher Memorial Library</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Law_NightsInBerlin_3P_MD3.vue?14d9e42d